module.exports = __webpack_public_path__ + "static/logo-vasiliev-ca5b3d0c8c05a5e3afab81f6673030a2.png";